import * as types from './courseReference.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_COURSE_REFERENCE,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_COURSE_REFERENCE,
		payload,
	}),
	get: payload => ({
		type: types.GET_COURSE_REFERENCE,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_COURSE_REFERENCE,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_COURSE_REFERENCE,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
